import { Injectable } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SupabaseService } from '../supabase/supabase.service';
import { inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardService {
  constructor(private supabaseService: SupabaseService, private router: Router) {}

  async isAdmin(): Promise<boolean> {
    const result = await this.supabaseService.getUser();
    const user = result?.data?.user;
    
    if (!user) {
      return false;
    }

    if (typeof user === 'object' && 'user_metadata' in user) {
      const metadata = (user as any).user_metadata;
      return metadata?.['role'] === 'admin';
    }

    return false;
  }
}

export const adminGuard: CanActivateFn = async (route, state) => {
  const guardService = inject(AdminGuardService);
  const router = inject(Router);

  const isAdmin = await guardService.isAdmin();

  if (!isAdmin) {
    // Redirect to 403 Forbidden page instead of login
    router.navigate(['/403']);
    return false;
  }

  return true;
};
